const APP_ID = 390634665211963

export { APP_ID }
